import { EntityNotes } from "@modernary/mui/components/note";
import EntityAudits from "@/components/EntityAudits.vue";
import { RouterView, type RouterOptions } from "vue-router";
import { EntityDocuments } from "@modernary/mui/components/document";

const names = {
  wells: "Well.Wells",
  list: "Well.WellList",
  base: "Well.WellBase",
  view: "Well.WellView,",
  new: "Well.WellNew",
  edit: "Well.WellEdit",
  notes: "Well.WellNotes",
  noteEdit: "Well.WellNoteEdit",
  noteNew: "Well.WellNoteNew",
  documents: "Well.WellDocuments",
  documentEdit: "Well.WellDocumentEdit",
  documentNew: "Well.WellDocumentNew",
  audit: "Well.WellAudit",
};

export { names as wellRouteNames };

const wellRoutes: RouterOptions["routes"] = [
  {
    path: "/wells",
    name: names.wells,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Wells", lookupGroups: ["WellStatus"] },
        component: () => import("@/views/well/WellList.vue"),
      },
      {
        path: "new/:facilityId(\\d+)?",
        component: () => import("@/views/well/WellBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Well New", isNew: true },
            component: () => import("@/views/well/WellEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/well/WellBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Well View" },
            component: () => import("@/views/well/WellView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Well Edit", isForm: true },
            component: () => import("@/views/well/WellEdit.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Well Notes" },
            component: {
              render: () => <EntityNotes idField="wellId" routeNamePrefix="Well.WellNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Well Note Edit", isForm: true },
            component: () => import("@/views/well/WellNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Well Note New", isForm: true },
            component: () => import("@/views/well/WellNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Well Documents" },
            component: {
              render: () => <EntityDocuments idField="wellId" routeNamePrefix="Well.WellDocument" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Well Document Edit", isForm: true },
            component: () => import("@/views/well/WellDocument.vue"),
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Well Document New", isForm: true },
            component: () => import("@/views/well/WellDocuments.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Well Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Well" />,
            },
          },
        ],
      },
    ],
  },
];
export default wellRoutes;
